import React from "react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
// import { Provider } from "react-redux";
// import store from "./state/store";
import theme from "./theme";
import getLibrary from "./utils/getLibrary";

import { Web3ReactProvider, createWeb3ReactRoot } from "@web3-react/core";
import { NetworkContextName } from "./constants/index";
import TextProvider from "./hooks/context";

// import ListsUpdater from "./state/lists/updater";
// function Updaters() {
//   return (
//     <>
//       <ListsUpdater />
//     </>
//   );
// }

const Web3ReactProviderReloaded = createWeb3ReactRoot(NetworkContextName);





const AppProvider = ({ children }: { children: JSX.Element }) => {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3ReactProviderReloaded getLibrary={getLibrary}>
        {/* @ts-ignore */}
         <TextProvider>


            {/* <Updaters /> */}
            <ChakraProvider theme={theme}>
              
            {/* <ColorModeScript /> */}
            <ColorModeScript />
              {children}
              
              
              </ChakraProvider>
          </TextProvider>
      </Web3ReactProviderReloaded>
    </Web3ReactProvider>
  );
};

export default AppProvider;
